<template>
    <div>
        <div class="relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-gray-500 focus-within:border-gray-500">
            <label :for="id" class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900">
                <slot v-if="headline"></slot>
            </label>
            <input v-bind:value="value"
                   :id="id"
                   :type="type"
                   v-on:input="$emit('input', $event.target.value)"
                   v-on:keyup.enter="$emit('enter')"
                   class="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                   :placeholder="defaultSlot"
                   :class="{'border-red-500 bg-red-100': hasError}"
            />
            
        </div>
        <p class="ml-4 mt-1 text-sm text-gray-500" v-if="hasHelperSlot">
               <i class="fa fa-info mr-2"></i> <slot name="helper"></slot>
            </p>
    </div>
</template>

<script>
import uniqueId from "lodash/uniqueId";

export default {
    name: "InputTextSecondary",

    props: {
        value: {},
        hasError: {},
        type: {
            default: 'text',
        },
        headline: {
            default: true,
        }
    },

    data: () => ({
        id: uniqueId(),
    }),

    computed: {
        hasHelperSlot() {
            return !!this.$slots['helper'];
        },
        defaultSlot() {
            if (!this.$slots['default']) {
                return '';
            }
            return this.$slots['default'][0].text.trim();
        }
    },


}
</script>

<style scoped>

</style>
